'use strict'

module.exports = emphasis

var all = require('../all')

/* Transform emphasis. */
function emphasis(h, node) {
  return h(node, 'em', all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/emphasis.js
// module id = 890
// module chunks = 95715928098905 168707334958949